// extracted by mini-css-extract-plugin
module.exports = {"spotSelector":"coefficientiUP_spotSelector__1PFcB","spotRegionSelect":"coefficientiUP_spotRegionSelect__2HJ9b","regioneSelector":"coefficientiUP_regioneSelector__l8gqH"};